import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { FindBorrowersStore } from '../stores';

export const useFindBorrowersStore = () => useContext<{
  findBorrowersStore: FindBorrowersStore
}>(StoreContext);
